import type { AppRouteRecordRaw } from "#src/router/types";

import { IconReader } from "#src/components/iconReader/IconReader";
import ContainerLayout from "#src/layout/container-layout";
import { createElement, lazy } from "react";

const CrewPage = lazy(() => import("#src/features/Crews"));
const AppraisalsPage = lazy(() => import("#src/features/Appraisals"));
const CrewRequestsPage = lazy(() => import("#src/features/CrewRequests"));
const CrewMovementsPage = lazy(() => import("#src/features/CrewMovements"));

const routes: AppRouteRecordRaw[] = [
	{
		path: "/crew",
		Component: ContainerLayout,
		handle: {
			title: "Crew Management",
			icon: createElement(IconReader, { name: "usersfour" }) as any,
			order: 4, // after PMS (order 3)
			keepAlive: true,
		},
		children: [
			{
				path: "/crew/crew",
				Component: CrewPage,
				handle: { title: "Crew List" },
			},
			{
				path: "/crew/appraisals",
				Component: AppraisalsPage,
				handle: { title: "Appraisals" },
			},
			{
				path: "/crew/requests",
				Component: CrewRequestsPage,
				handle: { title: "Crew Requests" },
			},
			{
				path: "/crew/movements",
				Component: CrewMovementsPage,
				handle: { title: "Movements" },
			},
		],
	},
];

export default routes;
